import { isDefined } from '@vueuse/core'
import type { RouteMetaCustom, RouteRecordWithMeta } from './types'

export const validateRoutes = (routes: RouteRecordWithMeta[]) => {
  routes.forEach((route) => {
    if (route.children) {
      validateRoutes(route.children as unknown as RouteRecordWithMeta[])
      return
    }
    const meta = route.meta as RouteMetaCustom
    if (meta.isSystemUser && meta.isCustomer) {
      throw new Error(`Route ${String(route.name)} cannot be both system user and customer.`)
    }

    if (meta.isCustomer) {
      if (isDefined(meta.icon) || isDefined(meta.label) || isDefined(meta.accessibleBy)) {
        throw new Error(
          `Route ${String(route.name)} cannot be both customer and have icon, label or accessibleBy.`,
        )
      }
      if (meta.isSignup) {
        if (meta.showFilters || meta.showInNavbar) {
          throw new Error(
            `Route ${String(route.name)} cannot have showFilters or showInNavbar if isSignup is true.`,
          )
        }
      } else {
        if (!isDefined(meta.showFilters) || !isDefined(meta.showInNavbar)) {
          throw new Error(`Route ${String(route.name)} must have showFilters and showInNavbar.`)
        }
      }
    }
    if (meta.isSystemUser) {
      if (meta.requiresAuth !== true) {
        throw new Error(`Route ${String(route.name)} requires auth must be true.`)
      }
      if (isDefined(meta.isSignup) || isDefined(meta.showFilters) || isDefined(meta.showInNavbar)) {
        throw new Error(
          `Route ${String(route.name)} cannot be both system user and have isSignup, showFilters, showInNavbar.`,
        )
      }
      if (!isDefined(meta.icon) || !isDefined(meta.label) || !isDefined(meta.accessibleBy)) {
        throw new Error(`Route ${String(route.name)} must have icon, label and accessibleBy.`)
      }
    }
  })
}
